import styled from "styled-components";
import { xlg } from "../../../AppTheme.styled";

const StyledDesktopMenu = styled.div`
  position: sticky;
  top: 0;
  width: 235px;
  padding: 32px 16px;
  box-sizing: border-box;
  border-right: none;
  height: 100vh;
  box-shadow: 0px 10px 15px -3px rgba(26, 32, 44, 0.1),
    0px 4px 6px -2px rgba(26, 32, 44, 0.05);

  > img {
    margin: 0 25px 24px;
  }

  ${xlg} {
    width: 320px;
    padding: 32px;
  }
`;

export default StyledDesktopMenu;
